import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "./auth-middleware";
import { Role, type AppRole } from "@/lib/role";
import { hasRole } from "@/lib/role-presence";

function requireAppRole(role: AppRole) {
  return createMiddleware({ type: "function" })
    .middleware([requireSupabaseAuth])
    .server(async ({ next, context }) => {
      const { supabase, userId } = context;
      const ok = await hasRole(supabase, userId, role);
      if (!ok) throw new Error(`Forbidden: ${role} access required`);
      return next();
    });
}

export const requireAdmin = requireAppRole(Role.Admin);
export const requireEmployee = requireAppRole(Role.Employee);
